import _ from 'lodash'
import {
  SAVE_PROPERTY_ANALYTICS,
  SAVE_IS_PROPERTY_REPORT_AVAILABLE,
  SAVE_REALTY_TRACK_REPORT,
} from '../constants/actionTypes'

const initialState = {
  isPropertyReportAvailable: false,
  realtyTrackReport: {
    data: null,
    isAnalysisDataAvailable: false,
    comps: [],
    rentals: [],
    rentalRange: {
      high: null,
      low: null,
      median: null,
    },
    saleHistory: [],
    taxInfo: {},
    schools: [],
    neighborhood: {},
    highlights: [],
    hidePIR: false,
    showRentalEstimate: false,
  },
  similarProperties: [],
}

const propertyAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_PROPERTY_ANALYTICS:
      return Object.assign({}, state, action.propertyAnalytics)

    case SAVE_IS_PROPERTY_REPORT_AVAILABLE:
      return Object.assign({}, state, {
        isPropertyReportAvailable: action.isPropertyReportAvailable,
      })

    case SAVE_REALTY_TRACK_REPORT:
      return _.merge({}, state, { realtyTrackReport: action.value })

    default:
      return state
  }
}

export default propertyAnalyticsReducer
export { initialState }
